(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zomki-concierge"]) return;
  try {
    
function initZomkiConcierge(){
  document.querySelectorAll('[data-zmk-concierge]').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const dialog=root.querySelector('dialog');
    const launcher=root.querySelector('.zmk-concierge__launcher');
    const input=root.querySelector('input');
    const log=root.querySelector('[role="log"]');
    const greeting=root.querySelector('.zmk-concierge__greeting');
    const greetingKey='zmk-help-greeted-v1';
    function rememberGreeting(){try{sessionStorage.setItem(greetingKey,'1');}catch(error){}}
    function dismissGreeting(){greeting.hidden=true;rememberGreeting();}
    function openHelp(){dismissGreeting();if(!dialog.open)dialog.show();launcher.setAttribute('aria-expanded','true');input.focus({preventScroll:true});}
    function closeHelp(restoreFocus){if(dialog.open)dialog.close();launcher.setAttribute('aria-expanded','false');if(restoreFocus)launcher.focus({preventScroll:true});}
    launcher.addEventListener('click',()=>{if(dialog.open)closeHelp(true);else openHelp();});
    root.querySelector('.zmk-concierge__greeting-open').addEventListener('click',openHelp);
    root.querySelector('.zmk-concierge__greeting-close').addEventListener('click',()=>{dismissGreeting();launcher.focus({preventScroll:true});});
    root.querySelector('.zmk-concierge__close').addEventListener('click',()=>closeHelp(true));
    dialog.addEventListener('cancel',event=>{event.preventDefault();closeHelp(true);});
    dialog.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();closeHelp(true);}});
    dialog.addEventListener('close',()=>launcher.setAttribute('aria-expanded','false'));
    document.addEventListener('click',event=>{if(dialog.open&&!root.contains(event.target))closeHelp(false);});
    function reply(topic){
      const template=root.querySelector('template[data-reply="'+topic+'"]')||root.querySelector('template[data-reply="fallback"]');
      const box=document.createElement('div');box.className='zmk-concierge__message';box.append(template.content.cloneNode(true));log.append(box);
      while(log.children.length>24)log.firstElementChild.remove();
      log.scrollTop=log.scrollHeight;
    }
    root.querySelectorAll('[data-topic]').forEach(button=>button.addEventListener('click',()=>reply(button.dataset.topic)));
    root.querySelector('form').addEventListener('submit',event=>{
      event.preventDefault();const text=input.value.trim();if(!text)return;
      const user=document.createElement('p');user.className='zmk-concierge__message zmk-concierge__message--user';user.textContent=text;log.append(user);input.value='';
      const q=text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
      let topic='fallback';
      if(/talla|medida|ancho|pecho|size|altura|ajuste/.test(q))topic='size';
      else if(/devol|reembol|cambi[oa]|defect|roto|equivoc/.test(q))topic='returns';
      else if(/pedido|seguimiento|localiz|tracking|cancel|mi compra/.test(q))topic='order';
      else if(/envio|enviar|plazo|tarda|entrega|portes|lleg|canaria|baleare|peninsula/.test(q))topic='shipping';
      else if(/pag[oa]|tarjeta|paypal|bizum|klarna|financi|seguro|seguridad/.test(q))topic='payment';
      else if(/conjunto|chandal|look|dos prendas|ambas prendas|completo/.test(q))topic='looks';
      else if(/peque|infantil|nino|nina|anos|junior|kids/.test(q))topic='kids';
      else if(/calcetin|calcetines|sock|montana/.test(q))topic='socks';
      else if(/hombre|masculin|chico|caballero/.test(q))topic='men';
      else if(/mujer|femenin|chica|senora/.test(q))topic='women';
      else if(/ropa|prenda|camiset|sudader|pantal|leggin|deport|compr|precio|catalog|barat|novedad|unisex/.test(q))topic='catalog';
      reply(topic);input.focus({preventScroll:true});
    });
    let greeted=false;try{greeted=sessionStorage.getItem(greetingKey)==='1';}catch(error){}
    if(!greeted){greeting.hidden=false;rememberGreeting();}
  });
}
initZomkiConcierge();
document.addEventListener('shopify:section:load',initZomkiConcierge);
document.addEventListener('click',event=>{const link=event.target.closest('a[href$="#zmk-tallas"]');if(!link)return;const target=document.getElementById('zmk-tallas');if(target){if(target.tagName==='DETAILS')target.open=true;document.querySelectorAll('.zmk-concierge__panel[open]').forEach(panel=>panel.close());}});
if(location.hash==='#zmk-tallas'){const details=document.getElementById('zmk-tallas');if(details&&details.tagName==='DETAILS')details.open=true;}

  } catch(e) { console.error(e); }
})();
})();
